import MobileFloatingActionButton from "../../../../../../../pages/FloatingItems/MobileFloatingActionButton";
import OverviewTabs from "./OverviewMobileContent/OverviewTabs";

const OverviewMobile = () => {
  return (
    <>
      <OverviewTabs />
      <MobileFloatingActionButton trackerDataId="850" saveTrackerDataId="851" />
    </>
  );
};

export default OverviewMobile;
